import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  label: {
    color: "#FFF",
  },
  grid: {
    marginTop: "0.7%",
  },
  gridItem: {
    display: "flex",
    flexDirection: "row",
    paddingBottom: "10px",
  },
  tooltipText: {
    fontFamily: "Montserrat",
  },
}));
